import { produce } from "immer";
import { theme } from "../../theme/theme";
import { CLEAR_ALL_ERROR_MESSAGE, CLEAR_ERROR_MESSAGE, DATA_ASSET_ACTIVE_TAB, LOAD_API_DATA, RESET_FORM_VALUE, SET_API_DATA, SET_DIMENSIONS, SET_DIMENSIONS_DATA, SET_ERROR_MESSAGE, SET_FORM_OPTION, SET_FORM_OPTION_OBJECT_VALUE, SET_FORM_OPTION_OBJECTS_OBJECT_VALUE, SET_FORM_OPTIONOBJECTS_OBJECT_VALUE, SET_FORM_VALUE, SET_FORM_VALUEOBJ } from "./dataAsset.type";
const INITAL_STATE = {
    apiData: {

        assetSummary: {
            status: "idle",
            data: {
                description: "This table contains data related advertising brands campaigns on Amazon. It includes information such as the search terms used, the date of the campaign, the type of match used, the campaign status, and the campaign budget amount. Additionally, it provides data on various performance metrics, such as attributed sales, ROAS (Return on Ad Spend), units sold, sales of other SKUs, purchases, and cost per click. This table is essential for analyzing the effectiveness and profitability of advertising campaigns and optimizing future strategies.",
                dataList: [{ title: "Active Rules", value: "10", color: theme.colors.primary },
                { title: "Successful runs in last 30 days", value: "140 of 180", color: theme.colors.primary },
                { title: "Freshness", value: "25%", color: parseInt("25%".split("%")[0]) <= 55 ? theme.colors.fail : parseInt("25%".split("%")[0]) >= 85 ? theme.colors.success : theme.colors.primary },
                { title: "Total Quality Score", value: "92.6%", color: theme.colors.success },
                { title: "Last Updated", value: "02 days ago", color: theme.colors.primary },
                ],
                country: "United Kingdom",
                data_prod_name: "Amazon",
                region: "EU",
                domain: "Advertising",
                created_by: "Veronika Lutfullina",
                chartData: {
                    title: "Quality Score Trend",
                    chartType: "SimpleLine",
                    display1: "displayFields",
                    value1: "displayValue",
                    displayFields: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                    displayValue: [30, 42, 20, 34, 25, 90, 80]
                }
            },
            isError: false,
            errorMessage: "",
            loading: false

        },
        runProfiler: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: "",
            message: ""
        },
        profileCde: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        configureColumnDQRule: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        recommendateRule: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        sampleData: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        submitCongifureRule: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        configureAssetDQRule: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        dqRuleHistory: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        dqAssetRuleHistory: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        dimensions: {
            data: []
        },
        dimensionsData: {
            status: 'idle',
            data: [],
            isError: false,
            errorMessage: ""
        },
        cde: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        dimensionWeightage: {
            status: "idle",
            data: [],
            isError: false,
            errorMessage: ""
        },
        adlsDirectory: {
            loading: false,
            status: "idle",
            isError: false,
            errorMessage: "",
            data: []
        },
        addedTag:{
            loading: false,
            status: "idle",
            isError: false,
            errorMessage: "",
            data: []
        },
    },
    formData: {
        chartData: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        cdeform: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        validValues: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        dqRuleHistoryForm: {
            value: "",
            valueAsObj: {},
            loading: false,
            isError: false,
            errorMessage: "",
            options: [],

        },
        dqRuleHistoryAssetForm: {
            value: "",
            valueAsObj: {},
            loading: false,
            isError: false,
            errorMessage: "",
            options: [],

        },
        configureColumnDQRuleform: {
            value: "",
            valueAsObj: {},
            loading: false,
            isError: false,
            errorMessage: "",
            options: [],

        },
        configureAssetDQRuleform: {
            value: "",
            valueAsObj: {},
            options: [],

            loading: false,
            isError: false,
            errorMessage: ""
        },
        selectedProfile: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        selectedRules: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        addColumns: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        dimension: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        cdeDimension: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        dimensionWeightageForm: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        ruleName: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        ruleDescription: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        dqRuleCheck: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        expression: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        driftValue: {
            value: null,
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        driftWindow: {
            value: null,
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        ruleRecommendationform: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        driftPercentage: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
       
        dataAssetChecks: {
            value: "",
            valueAsObj: {},
            options: [
               
            ],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        threshold: {
            value: null,
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        threshold_type: {
            value: null,
            valueAsObj: {},
            options: [{ name: "Percentage" }, { name: "Count" }],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        drift_type: {
            value: null,
            valueAsObj: {},
            options: [{ name: "Percentage" }, { name: "Count" }],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        check_type: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
        adlsList: {
            value: "",
            valueAsObj: {},
            options: [],
            loading: false,
        },
        adlsDirectoryForm: {
            value: "",
            valueAsObj: {},
            options:  [],
            loading: false,
        },
        adlsFileName: {
            value: "",
            valueAsObj: {},
            options: [ ],
            loading: false,
        },
        filePickUp: {
            value: "Local",
            valueAsObj: { name: "Local" },
            options: [
                { name: "Local" },
                { name: "ADLS" },
                // { name: "Delta Table" },
            ],
            loading: false,
        },
        selectedFile: {
            value: null,
            valueAsObj: {},
            options: [],
            loading: false,
            isError: false,
            errorMessage: ""
        },
       
    },
    dataAssetActiveTab: 0

}

const dataAssetReducer = (state = INITAL_STATE, { type, payload }) => {
    switch (type) {
        case DATA_ASSET_ACTIVE_TAB: {
            return { ...state, dataAssetActiveTab: payload.value }
        }
        case SET_FORM_VALUE: {

            return produce(state, (draft) => {

                draft.formData[payload.formField].value = payload.value
            });
        }
        case SET_FORM_VALUEOBJ: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].valueAsObj = payload.valueAsObj
            });
        }
        case SET_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].isError = payload.isError
                draft.formData[payload.formField].errorMessage = payload.errorMessage
            });
        }
        case CLEAR_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                draft.formData[payload.formField].isError = false
                draft.formData[payload.formField].errorMessage = ""
            });
        }
        case CLEAR_ALL_ERROR_MESSAGE: {
            return produce(state, (draft) => {
                Object.keys(draft.formData).forEach((val) => {
                    draft.formData[val].isError = false
                    draft.formData[val].errorMessage = ""
                })

            });
        }
        case LOAD_API_DATA:
            return produce(state, (draft) => {
                draft.apiData[payload.apiField].loading = true
                draft.apiData[payload.apiField].status = "loading"
            })
        case RESET_FORM_VALUE:
            return produce(state, (draft) => {
                Object.keys(draft.formData).map((val) => {
                    draft.formData[val].value = INITAL_STATE.formData[val].value
                    draft.formData[val].valueAsObj = INITAL_STATE.formData[val].valueAsObj
                })

            })
        case SET_API_DATA:
            return produce(state, (draft) => {
                draft.apiData[payload.apiField].loading = false;
                draft.apiData[payload.apiField].status =
                    payload.status !== undefined && payload.status !== null
                        ? payload.status
                        : "success";
                draft.apiData[payload.apiField].data = payload.data;
            });
        case SET_FORM_OPTION:
            return produce(state, (draft) => {
                draft.formData[payload.formField].loading = false;
                draft.formData[payload.formField].options = payload.data;
            });
        case SET_FORM_OPTION_OBJECT_VALUE:
            return produce(state, (draft) => {
                // draft.formData[payload.formField].loading = false;
                draft.formData[payload.formField].options.filter((val) => val[payload.idField] === payload.id)[0][payload.optionField] = payload.value;
            });
        case SET_FORM_OPTION_OBJECTS_OBJECT_VALUE:
            return produce(state, (draft) => {
                let tempIndex = -1
                draft.formData[payload.formField].options.filter((val) => val[payload.idField] === payload.id)[0][payload.optionField].map((val1, index) => {
                    if (val1[payload.subIdField] === payload.subId) {
                        tempIndex = index
                    }
                })
                draft.formData[payload.formField].options.filter((val) => val[payload.idField] === payload.id)[0][payload.optionField][tempIndex] = payload.value
            });
        case SET_FORM_OPTIONOBJECTS_OBJECT_VALUE:
            return produce(state, (draft) => {
                draft.formData[payload.formField].options[payload.optionField] = payload.value
            })
        case SET_DIMENSIONS:
            return produce(state, (draft) => {
                if(draft.apiData[payload.apiField].data){
                    draft.apiData[payload.apiField].data = payload.data
                }
              
            })
        case SET_DIMENSIONS_DATA:
            return produce(state, (draft) => {
                draft.apiData[payload.apiField].data = payload.data
                draft.apiData[payload.apiField].status = payload.status
            })
        // Return the current state if no action matches
        default:
            return state;
    }
}
export default dataAssetReducer;